import cookie from "cookie"

// /welcome is behind a flag until it replaces /sign-up (Phase 4 of
// docs/onboarding-rehaul-plan.md). On for everyone with
// NEXT_PUBLIC_ONBOARDING_V2=1; otherwise per browser, by visiting
// /welcome?ob=on (and /welcome?ob=off to leave).
export const ONBOARDING_FLAG_COOKIE = "ob_v2"
const ONE_YEAR_SECONDS = 365 * 24 * 60 * 60

const envEnabled = () => process.env.NEXT_PUBLIC_ONBOARDING_V2 === "1"

// `cookieHeader` on the server; the browser reads document.cookie
export const isOnboardingV2Enabled = (cookieHeader) => {
  if (envEnabled()) return true
  const header =
    cookieHeader !== undefined
      ? cookieHeader
      : typeof document !== "undefined"
      ? document.cookie
      : ""
  return cookie.parse(header || "")[ONBOARDING_FLAG_COOKIE] === "1"
}

export const flagCookie = (on) =>
  cookie.serialize(ONBOARDING_FLAG_COOKIE, on ? "1" : "", {
    path: "/",
    maxAge: on ? ONE_YEAR_SECONDS : 0,
    sameSite: "lax",
  })
